export default __webpack_public_path__ + "static/onlyBg-94ff99cb8d2e7360a786b7eab419ad3b.png";